module.exports = __webpack_public_path__ + "static/waterproof-mattress-protector-3-de8e40b1c408763559ce76b5153da61b.png";